var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarginIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "5 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_7604)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.5099 11.7998C32.0099 11.7998 31.6099 12.1998 31.6099 12.6998V17.3498C31.6099 17.8498 32.0099 18.2498 32.5099 18.2498C33.0099 18.2498 33.4099 17.8498 33.4099 17.3498V12.6998C33.4099 12.1998 33.0099 11.7998 32.5099 11.7998Z",
    fill: "#747E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 25.75C25.5001 25.75 25.1001 26.15 25.1001 26.65V31.3C25.1001 31.8 25.5001 32.2 26.0001 32.2C26.5001 32.2 26.9001 31.8 26.9001 31.3V26.65C26.9001 26.16 26.5001 25.75 26.0001 25.75Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.4898 11.7998C18.9898 11.7998 18.5898 12.1998 18.5898 12.6998V17.3498C18.5898 17.8498 18.9898 18.2498 19.4898 18.2498C19.9898 18.2498 20.3898 17.8498 20.3898 17.3498V12.6998C20.3898 12.1998 19.9798 11.7998 19.4898 11.7998Z",
    fill: "#747E87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.35 20.1699H17.63C17.13 20.1699 16.73 20.5699 16.73 21.0699C16.73 21.5699 17.13 21.9699 17.63 21.9699H18.59V31.2999C18.59 31.7999 18.99 32.1999 19.49 32.1999C19.99 32.1999 20.39 31.7999 20.39 31.2999V21.9699H21.35C21.85 21.9699 22.25 21.5699 22.25 21.0699C22.25 20.5699 21.84 20.1699 21.35 20.1699Z",
    fill: "#747E87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.37 20.1699H30.65C30.15 20.1699 29.75 20.5699 29.75 21.0699C29.75 21.5699 30.15 21.9699 30.65 21.9699H31.61V31.2999C31.61 31.7999 32.01 32.1999 32.51 32.1999C33.01 32.1999 33.41 31.7999 33.41 31.2999V21.9699H34.37C34.87 21.9699 35.27 21.5699 35.27 21.0699C35.27 20.5699 34.87 20.1699 34.37 20.1699Z",
    fill: "#747E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8602 22.0298H26.9002V12.6998C26.9002 12.1998 26.5002 11.7998 26.0002 11.7998C25.5002 11.7998 25.1002 12.1998 25.1002 12.6998V22.0298H24.1402C23.6402 22.0298 23.2402 22.4298 23.2402 22.9298C23.2402 23.4298 23.6402 23.8298 24.1402 23.8298H27.8602C28.3602 23.8298 28.7602 23.4298 28.7602 22.9298C28.7602 22.4298 28.3602 22.0298 27.8602 22.0298Z",
    fill: "#5ED5A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_7604",
    x: 0.72998,
    y: 0.799805,
    width: 50.54,
    height: 52.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.835294 0 0 0 0 0.658824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_7604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_7604",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginIcon);
export default __webpack_public_path__ + "static/media/marginIcon.94fe31684cb50197a0b5abaf7b1e205d.svg";
export { ForwardRef as ReactComponent };